// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { windowCode16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-window-code': IconWindowCode;
    }
}

/**
 * The icon component for the 'windowCode' icon
 */
export class IconWindowCode extends Icon {
    public constructor() {
        super(windowCode16X16);
    }
}

registerIcon('icon-window-code', IconWindowCode);
export const iconWindowCodeTag = 'nimble-icon-window-code';
